import { massUpdatableFields } from 'admin/lib/GroupUpdateHelpers/massUpdateableFields'

export interface SubOption {
  value: string
  label: any
}

export const updateableFilterOptions = () => {
  const optionsGrouped: { label: string; options: SubOption[] }[] = []
  Object.keys(massUpdatableFields).forEach(key => {
    const subOptions: SubOption[] = []
    for (const [key2, value] of Object.entries<string>(
      massUpdatableFields[key]
    ).sort((a, b) => a[1].localeCompare(b[1]))) {
      subOptions.push({ value: `${key}:${key2}`, label: value })
    }

    optionsGrouped.push({ label: key, options: subOptions })
  })
  return optionsGrouped
}
